import { render, staticRenderFns } from "./Anamnese.vue?vue&type=template&id=13024e44&scoped=true&"
import script from "./Anamnese.vue?vue&type=script&lang=js&"
export * from "./Anamnese.vue?vue&type=script&lang=js&"
import style0 from "./Anamnese.vue?vue&type=style&index=0&id=13024e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13024e44",
  null
  
)

export default component.exports